module.exports = __webpack_public_path__ + "static/img/data5-img.959298f9.png";